import {
  AspectRatio,
  Box,
  Card,
  CardBody,
  CardHeader,
  Flex,
  HStack,
  Stack,
  Text,
  Wrap,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";

export const TutorialPlayerPage = ({ tutorialData, setVault }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const clearQueryString = () => {
    navigate(location.pathname);
    setVault(false);
  };
  if (!tutorialData) return null;

  return (
    <Stack p="24px 32px" minH={"100vh"}>
      <Stack mt={"74px"}>
        <Wrap spacing={2} align="center">
          <Text
            fontSize="16px"
            fontWeight={400}
            color="#2D3748"
            cursor="pointer"
            _hover={{ textDecoration: "underline" }}
            onClick={() => clearQueryString()}
          >
            Lucro Tutorials
          </Text>
          <Text fontSize="16px" fontWeight={400} color="#1A202C">
            {">"}
          </Text>
          <Text fontSize="16px" fontWeight={700} color="#2D3748">
            {tutorialData.tutorial_title}
          </Text>
        </Wrap>

        <HStack spacing={2} flexWrap="wrap" mt="24px">
          {(tutorialData.tags || []).map((tag) => (
            <Box
              key={tag.id}
              backgroundColor={tag.label_color}
              fontFamily="Lato"
              borderRadius="40px"
              display="inline-flex"
              alignItems="center"
              height="28px"
              px="10px"
              fontWeight={700}
            >
              <Text fontSize="15px">{tag.name}</Text>
            </Box>
          ))}

          {tutorialData.video_duration && tutorialData.external_link && (
            <HStack spacing={1}>
              <Box fontSize="17px" color="#4A5568">
                •
              </Box>
              <Box
                fontSize="17px"
                color="#4A5568"
                fontWeight={500}
                fontFamily="Lato"
              >
                {`${tutorialData.video_duration} min watch`}
              </Box>
            </HStack>
          )}
        </HStack>

        <Flex
          mt="7px"
          align="center"
          justify="space-between"
          flexWrap="wrap"
          mb="10px"
        >
          <Text
            fontFamily="Poppins"
            fontWeight={600}
            fontSize="25px"
            color="#1A202C"
          >
            {tutorialData.tutorial_title}
          </Text>
        </Flex>

        <Card mt="4px" borderRadius="16px">
          <CardHeader padding={0}>
            <Box borderTopRadius="0px" overflow="hidden">
              <AspectRatio ratio={16 / 9}>
                <iframe
                  src={tutorialData.external_link}
                  allowFullScreen
                  style={{
                    borderRadius: "12px 12px 0 0 ",
                  }}
                  title={tutorialData.tutorial_title}
                />
              </AspectRatio>
            </Box>
          </CardHeader>

          <CardBody padding="24px">
            <Box
              w="100%"
              paddingX="20px"
              textAlign="left"
              alignItems="center"
              display="flex"
              flexDirection="column"
              spacing="10px"
            >
              <Box
                textAlign="center"
                bgColor="#E3EDFF"
                p="3px 10px"
                mb="5px"
                w="120px"
                borderRadius="4px"
                height="26px"
              >
                <Text
                  fontWeight={500}
                  fontSize="13px"
                  color="#536DEC"
                  fontFamily="Poppins"
                >
                  Recap
                </Text>
              </Box>

              <Text fontWeight={600} fontSize="22px" fontFamily="Poppins">
                Here’s What We Covered
              </Text>

              <Text mt="12px" fontSize="16px" fontWeight={400}>
                {tutorialData.tutorial_description}
              </Text>
            </Box>
          </CardBody>
        </Card>
      </Stack>
    </Stack>
  );
};
